/**
 * NewBuildBanner - "A new version is ready", with Reload, once a newer
 * build has gone live since this tab loaded (hooks/useNewBuild). The user,
 * 2026-10-20: a deploy reached nobody whose tab was already open, and
 * nothing told them. Reload rejoins the session as any reload does; "Not
 * now" puts the banner away for this sitting.
 */
import { useState } from 'react';
import useNewBuild, { loadedEntry } from '../hooks/useNewBuild';
import styles from '../styles/NewBuildBanner.module.css';

export default function NewBuildBanner() {
  // The entry this tab loaded is read once: it is what the tab IS, whatever the server serves later.
  const [loaded] = useState(loadedEntry);
  const newer = useNewBuild({ loaded });
  const [later, setLater] = useState(false);
  if (!newer || later) return null;
  return (
    <div className={styles.banner} role="status" data-testid="new-build-banner">
      <span>A new version is ready.</span>
      <button
        type="button"
        className={styles.reload}
        data-testid="new-build-reload"
        onClick={() => window.location.reload()}
      >
        Reload
      </button>
      <button type="button" className={styles.later} onClick={() => setLater(true)}>
        Not now
      </button>
    </div>
  );
}
